import React from 'react';
import { Box, Chip } from '@mui/material';

interface CharacterCounterProps {
  currentLength: number;
  maxLength: number;
}

const CharacterCounter = ({ currentLength, maxLength }: CharacterCounterProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      mt: 1
    }}
  >
    <Chip
      label={`${currentLength}/${maxLength}`}
      size="small"
      sx={{
        backgroundColor: 'background.default',
        color: 'text.secondary',
        fontWeight: 'bold'
      }}
    />
  </Box>
);

export default CharacterCounter;
